<template>
  <div v-if="institution">
    <div class="col-md-11 ml-auto mr-auto">
      <div>
        <h2>
          {{ $t(`${$store.state.experience.identifier}_title`) }}
          <shareWidget
            v-if="emb"
            style="float: right"
            :identifier="identifier"
          ></shareWidget>
        </h2>
      </div>

      <institutionComponent
        :isEmbedded="emb"
        :isProvided="true"
        :institution="institution"
      ></institutionComponent>
    </div>
    <div class="card card-blog col-md-11 ml-auto mr-auto">
      <DivComponent :config="config"></DivComponent>
    </div>
  </div>
</template>
<script text="javascript" src="https://mcorp.no/lib/mediasync.js"></script>
<script>
// The Root component for viewing an IREAL experiment

// @ is an alias to /src
import httpMixin from "ireal-vue/mixins/http-mixin.js";
import Bus from "ireal-vue/services/bus.js";
import shareWidget from "ireal-vue/widgets/ShareWidget.vue";

// clean intervals on webpack reloading
const intervals = intervals || [];
intervals.forEach(clearInterval);

export default {
  name: "ireal-viewer",
  props: ["identifier", "emb"],
  components: { shareWidget },
  mixins: [httpMixin],
  metaInfo() {
    return {
      title: this.identifier,
      // ...
    };
  },
  data() {
    return {
      provided: false,
      institution: undefined,
      parameters: [],
      progress: 0,
      last_tick: undefined,
    };
  },
  mounted() {
    this.load();
    this.tickInterval = window.setInterval(() => {
      //tick only when observation is running or while component illustration is building ( histogram static for example)
      if (this.$store.getters.isPlaying) {
        Bus.$emit("ireal-tick");
      }
    }, 100);

    // Initialized progress on start
    Bus.$on("ireal-start", () => {
      this.progress = 0;
      this.last_tick = new Date().getTime();
    });
    Bus.$on("ireal-un-pause", () => {
      this.last_tick = new Date().getTime();
    });
    Bus.$on("ireal-tick", () => {
      if (this.$store.getters.isPlaying) {
        if (!this.$store.getters.lagging) {
          this.progress +=
            (new Date().getTime() - this.last_tick) * this.$store.getters.speed;
          if (this.progress > this.$store.getters.duration) {
            this.progress = this.$store.getters.duration;
          }
          this.$store.commit("setProgress", this.progress);
        }
      }
      this.last_tick = new Date().getTime();
    });
    Bus.$on("ireal-endpoint", async (time) => {
      this.progress = time;
      Bus.$emit("ireal-resync", this.progress);
    });
    Bus.$on("ireal-back", (time) => {
      this.progress -= time;
      Bus.$emit("ireal-resync", this.progress);
    });
    Bus.$on("ireal-forward", (time) => {
      this.progress += time;
      Bus.$emit("ireal-resync", this.progress);
    });

    intervals.push(this.tickInterval);
  },
  beforeDestroy() {
    if (typeof this.tickInterval !== "undefined")
      clearInterval(this.tickInterval);
    Bus.$off("ireal-start");
    Bus.$off("ireal-stop");
    Bus.$off("ireal-pause");
    Bus.$off("ireal-un-pause");
    Bus.$off("ireal-tick");
    Bus.$off("ireal-back");
    Bus.$off("ireal-speed");
    Bus.$off("ireal-forward");
    // désabonnement de l'evt sinon, en changeant vers une expérience qui n'a pas de message
    // l'ireal-mixin va continuer à chercher une clé 'text' dans i18n
    Bus.$off("value-changed");
    this.$store.commit("stopPlayer");
    this.$store.commit("experience", undefined);
    this.$store.commit("clearParams");
  },
  methods: {
    async load() {
      const experience = await this.getExperience(this.identifier);
      this.institution = await this.getObject(
        "institution",
        experience.institution.institution
      );
      this.$store.commit("experience", experience);
    },
  },
  computed: {
    experience() {
      return this.$store.getters.experience;
    },
    config() {
      return typeof this.experience !== "undefined" &&
        this.experience.layout !== undefined
        ? this.experience.layout
        : "";
    },

    elements() {
      return typeof this.config !== "undefined" ? this.config.elements : [];
    },
    component() {
      return typeof this.config !== "undefined"
        ? `${this.config.component}Component`
        : "";
    },
  },
};
</script>
